import { Text } from 'recharts';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

export const CustomLabelYText = ({ dx, dy, value }) => {
  const theme = useTheme();
  return (
    <Text
      fill={theme.fuel6Tokens.JddcColorTextPrimary}
      style={{ fontSize: 12 }}
      dx={dx}
      dy={dy}
      textAnchor="start"
      transform="rotate(-90)"
      verticalAnchor="middle"
      width={160}
      x={0}
      y={0}
    >
      {value}
    </Text>
  );
};

CustomLabelYText.propTypes = {
  dx: PropTypes.number.isRequired,
  dy: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired
};
